import { lazy, LazyExoticComponent, ComponentType } from 'react';

/**
 * Wraps a dynamic import with retries. Handles transient chunk load failures
 * (e.g. "Importing a module script failed" after deploy or on slow networks).
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  importFn: () => Promise<{ default: T }>,
  retries = 2,
  delayMs = 1000
): LazyExoticComponent<T> {
  return lazy(async () => {
    let lastErr: unknown;
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        return await importFn();
      } catch (e) {
        lastErr = e;
        if (attempt < retries) {
          await new Promise((r) => setTimeout(r, delayMs));
        }
      }
    }
    throw lastErr;
  });
}
